import React, { Component } from 'react';
import { Radio } from 'antd';
import util from '@util/index';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class ChangeType extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      statis: { all, settled, deposit, other, oregistapp },
      defaultValue,
      onChange,
    } = this.props;
    return (
      <RadioGroup onChange={onChange} defaultValue={defaultValue}>
        <RadioButton value="-1" loading>
          全部<span>{all ? util.numberFormat(all) : 0}</span>
        </RadioButton>
        <RadioButton value="1">
          工位收入
          <span>{settled ? util.numberFormat(settled) : 0}</span>
        </RadioButton>
        <RadioButton value="2">
          地址收入
          <span>{oregistapp ? util.numberFormat(oregistapp) : 0}</span>
        </RadioButton>
        <RadioButton value="0">
          押金<span>{deposit ? util.numberFormat(deposit) : 0}</span>
        </RadioButton>
        <RadioButton value="3">
          其他收入<span>{other ? util.numberFormat(other) : 0}</span>
        </RadioButton>
      </RadioGroup>
    );
  }
}

export default ChangeType;



// WEBPACK FOOTER //
// ./src/components/incubator/bill/ChangeType.js